import React from "react";
import { Link } from "react-router-dom";
import ShareCommon from "./component/ShareCommon";
import { generateResizedImageUrl } from "../utils/httpService";
import sandeshske from "../assets/sandeshske.png";

// Functional component for displaying common content
const CommonContent = (props) => {
  // Function to handle share button click
  const onShareClick = (e) => {
    document.getElementById("common-share-dropdown")?.classList.remove("d-none");
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return (
    <div
      className={`custom-card ${props?.dataclass} ${props?.dataclass2 ? "share-common-trend" : "share-common"
        }  ${props?.dataclass3 ? "min-h-video-page" : ""}`}
    >
      {props?.url ? (
        <Link
          target="_parent"
          to={`/${props.url}`}
          title={props?.title}
          className="clearfix a"
        >
          <div className="float-left">
            <div className="skeleton-sub">
              <img
                loading="lazy"
                src={
                  !props.src || props.src === "undefined" || props.src === "null" || props.src === ""
                    ? sandeshske
                    : generateResizedImageUrl(115, 90, props.src)
                }
                // key={props.src}
                alt={props?.alt}
                title={props?.title}
              />
              <span className="button-hover subvideo-tagline">
                {props?.time}{" "}
              </span>
              {props?.type === "video" ? (
                <p className="playicon-subhome-subcategory">
                  <i className="fas fa-play"></i>
                </p>
              ) : (
                ""
              )}
            </div>
            {props.post_type === 3 || props.post_type === 4 ? (
              <span className="button-hover timer_ subvideo-tagline">
                {props.time}{" "}
              </span>
            ) : (
              ""
            )}
            {props.publish_date ? (
              <span className="blog-time">
                <i className="far fa-clock mr-2"></i>
                {props.publish_date}
              </span>
            ) : (
              ""
            )}
          </div>
          <div className="">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
              {parseInt(props.is_live) === 1 && props?.dataclass !== 'top10' && (
                <span className="live-now-badge" style={{ padding: '2px 8px', fontSize: '11px', margin: 0 }}>
                  <span className="live-now-dot"></span>
                  LIVE
                </span>
              )}
              {props.category && (
                <p className="color-red m-0" style={{ fontSize: '12px', fontWeight: 'bold' }}>{props.category}</p>
              )}
            </div>
            {window.location.pathname.includes("/videos") ? (
              <p className="ellipsis">
                {parseInt(props.is_live) === 1 && props?.dataclass === 'top10' && (
                  <span className="live-now-badge" style={{ padding: '4px', fontSize: '11px', margin: '0 6px 0 0', display: 'inline-flex', verticalAlign: 'middle', border: '1px solid #dc2626', backgroundColor: 'transparent' }}>
                    <span className="live-now-dot"></span>
                  </span>
                )}
                {`${props.title}`}
              </p>
            ) : (
              <h3 className="ellipsis">
                {parseInt(props.is_live) === 1 && props?.dataclass === 'top10' && (
                  <span className="live-now-badge" style={{ padding: '4px', fontSize: '11px', margin: '0 6px 0 0', display: 'inline-flex', verticalAlign: 'middle', border: '1px solid #dc2626', backgroundColor: 'transparent' }}>
                    <span className="live-now-dot"></span>
                  </span>
                )}
                {`${props.title}`}
              </h3>
            )}
          </div>
          <div class="dropleft">
            <button
              name={props.icname}
              id={props.icname}
              onClick={(e) => onShareClick(e)}
              className="dropbtn ml-2"
            >
              <i class="fa fa-share-alt"></i>
            </button>
            <div class="dropdown-menu">
              <ShareCommon
                id="common-share-dropdown"
                url={props.url}
                media={props.src}
                title={props.title}
                dataid={props.id}
              />
            </div>
          </div>
        </Link>
      ) : (
        <a
          href="javascript:void(0)"
          className="share-common-trend-video share-common clearfix a"
        >
          <div className="float-left">
            <div className="skeleton-sub">
              <img
                loading="lazy"
                src={generateResizedImageUrl(800, 450, props.src)}
                alt={props?.media_title}
                title={props?.title}
                key={Math.random()}
              />
              <span className="button-hover subvideo-tagline">
                {props?.time}{" "}
              </span>
              {props?.type === "video" ? (
                <p className="playicon-subhome-subcategory">
                  <i className="fas fa-play"></i>
                </p>
              ) : (
                ""
              )}
            </div>
            {props.post_type === 3 || props.post_type === 4 ? (
              <span className="button-hover timer_ subvideo-tagline">
                {props.time}{" "}
              </span>
            ) : (
              ""
            )}
            {props.publish_date ? (
              <span className="blog-time">
                <i className="far fa-clock mr-2"></i>
                {props.publish_date}
              </span>
            ) : (
              ""
            )}
          </div>
          <div className="">
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap', marginBottom: '4px' }}>
              {parseInt(props.is_live) === 1 && props?.dataclass !== 'top10' && (
                <span className="live-now-badge" style={{ padding: '2px 8px', fontSize: '11px', margin: 0 }}>
                  <span className="live-now-dot"></span>
                  LIVE
                </span>
              )}
              {props.category && (
                <p className="color-red m-0" style={{ fontSize: '12px', fontWeight: 'bold' }}>{props.category}</p>
              )}
            </div>
            <p className="ellipsis">
              {parseInt(props.is_live) === 1 && props?.dataclass === 'top10' && (
                <span className="live-now-badge" style={{ padding: '4px', fontSize: '11px', margin: '0 6px 0 0', display: 'inline-flex', verticalAlign: 'middle', border: '1px solid #dc2626', backgroundColor: 'transparent' }}>
                  <span className="live-now-dot"></span>
                </span>
              )}
              {`${props.title}`}
            </p>
          </div>
          <div class={`dropleft ${props?.bg === "black" ? "bg-black" : ""}`}>
            <button
              onClickCapture={(e) => onShareClick(e)}
              className="dropbtn ml-2"
            >
              <i class="fa fa-share-alt"></i>
            </button>
            <div class="dropdown-menu">
              <ShareCommon
                id="common-share-dropdown"
                url={props.url}
                media={props.src}
                title={props.title}
                dataid={props.id}
              />
            </div>
          </div>
        </a>
      )}
    </div>
  );
};

export default CommonContent;
